import redirect from './redirect.actions';

export default {
  redirect,
  trackingFromBackend: 'track.trackingFromBackend',
  trackingOnboarding: 'track.trackingOnboarding',
};
